import { getColor } from '@/helpers/utils';

interface DomainRankCellRendererProps {
  num: number | string | null | undefined;
}

const DomainRankCellRenderer = ({ num }: DomainRankCellRendererProps) => {
  const getDomainRankColor = (num: number) => {
    if ((num >= 0 && num < 15) || num === 0) return getColor('success');
    else if (num >= 15 && num < 30) return getColor('info');
    else if (num >= 30 && num < 50) return '#bb881d';
    else if (num >= 50 && num < 70) return getColor('warning');
    else if (num >= 70) return getColor('danger');
    else return getColor('danger');
  };
  return (
    num &&
    num !== -1 && (
      <span
        style={{ backgroundColor: getDomainRankColor(Number(num)) }}
        className="px-2 h-auto py-1 rounded-2 fs--2 fw-bold text-light"
      >
        {num}
      </span>
    )
  );
};

export default DomainRankCellRenderer;
